import { keyframes, css } from 'styled-components'

const textAnim1 = keyframes`
  0%{
    animation-timing-function: cubic-bezier(0,0,0,1);
     color: #FFB000
  }
  100%{
     color: #ff3920
  } 
`
const scaleAnim = keyframes`
  0%{
    animation-timing-function: cubic-bezier(.33,1,0,1);
    transform: scale(1)
   }
  50%{
    animation-timing-function: cubic-bezier(0,0,0,1);

    transform: scale(.73)
  }
  100%{
    transform: scale(1)
   } 
`
export const textAnim = css`
  ${textAnim1} 0.25s 1 forwards, ${scaleAnim} 0.33s 1 forwards
`
const yellowDivOpa1 = keyframes`
  0%{
    animation-timing-function: cubic-bezier(0,0,0,1);
    opacity: 0;
    }
   
  100%{
    opacity:1
  } 
`
export const yellowDivOpa = css`
  ${yellowDivOpa1} 0.25s 1 forwards
`

const whiteDivOpa1 = keyframes`
  0%{
    animation-timing-function: cubic-bezier(0,0,.2,1);
    opacity: 0;
    }
  33%{
    animation-timing-function: cubic-bezier(1.5,3.6,.2,1);
    opacity: 0.5;
    }
  100%{
    opacity:0
  } 
`

export const whiteDivOpa = css`
  ${whiteDivOpa1} 0.5s 1 forwards
`
